<template>
    <div>
        <el-row class="u-mt-10 u-mb-20">
            <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="24" v-if="$store.state.user.tipo > 3 && $store.state.user.tipo <= 8">
                    <el-select @change="changeFiltros()" v-model="filtro.instituicao_id" filterable placeholder="Pesquisar Instituição" clearable>
                        <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"> </el-option>
                    </el-select>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :xs="24" :sm="12" :md="12">
                    <el-input v-model="filtro.nome" placeholder="Pesquisar por nome" @keyup.native.enter="changeNome()"></el-input>
                </el-col>
                <el-col :xs="24" :sm="6" :md="6">
                    <el-select clearable placeholder="Modalidade" no-data-text="Selecione a modalidade" v-model="filtro.modalidade"  @change="changeFiltros()">

                        <el-option :key="1" label="INFANTIL 02 ANOS" value="2"></el-option>
                        <el-option :key="2" label="INFANTIL 03 ANOS" value="3"></el-option>
                        <el-option :key="3" label="INFANTIL 04 ANOS" value="4"></el-option>
                        <el-option :key="4" label="INFANTIL 05 ANOS" value="5"></el-option>

                        <el-option :key="5" label="1º ANO" value="6"></el-option>
                        <el-option :key="6" label="2º ANO" value="7"></el-option>
                        <el-option :key="7" label="3º ANO" value="8"></el-option>
                        <el-option :key="8" label="4º ANO" value="9"></el-option>
                        <el-option :key="9" label="5º ANO" value="10"></el-option>
                        <el-option :key="10" label="6º ANO" value="11"></el-option>
                        <el-option :key="11" label="7º ANO" value="12"></el-option>
                        <el-option :key="12" label="8º ANO" value="13"></el-option>
                        <el-option :key="13" label="9º ANO" value="14"></el-option>

                        <el-option :key="14" label="EJA - 1º ANO" value="30"></el-option>
                        <el-option :key="15" label="EJA - 2º E 3º ANOS" value="31"></el-option>
                        <el-option :key="16" label="EJA - 4º E 5º ANOS" value="32"></el-option>
                        <el-option :key="17" label="EJA - 6º E 7º ANOS" value="33"></el-option>
                        <el-option :key="18" label="EJA - 8º E 9º ANOS" value="34"></el-option>

                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="6" :md="6">
                    <el-select clearable placeholder="Data confirmação" no-data-text="Selecione a data" v-model="filtro.data"  @change="changeFiltros()">
                        <el-option :key="1" label="21/01/2026" value="21/01/2026"></el-option>
                        <el-option :key="2" label="22/01/2026" value="22/01/2026"></el-option>
                        <el-option :key="3" label="23/01/2026" value="23/01/2026"></el-option>
                        <el-option :key="4" label="26/01/2026" value="26/01/2026"></el-option>                        
                    </el-select>
                </el-col>
            </el-row>
        </el-row>
        <div class="u-mt-10" v-if="filtro.modalidade">
                <el-row>
                    <el-col :xs="24" :sm="24" :md="24" class="u-text-right">
                        <el-button @click="renderPdfRelatorioInscritos('agendados')" :loading="loadingButtonPdf" type="primary">LISTA DE AGENDADOS</el-button>                        
                        <el-button @click="renderPdfRelatorioInscritos('espera')" :loading="loadingButtonPdf" type="primary">LISTA DE ESPERA</el-button>
                    </el-col>
                </el-row>
            </div>

        <div class="container-table">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th>Posição</th>
                        <th>
                            Aluno / Responsável
                        </th>                        
                        <th>Data de Nascimento</th>
                        <th>Cod. Inscrição</th>
                        <th>Telefone</th>                                                
                        <th style="text-align: center;">Datas</th>
                        <th>Status da Agenda</th>
                        <th>Ação</th>
                    </tr>
                </thead>
                <tbody v-if="statusList">
                    <tr v-for="item in items" :key="item.id">
                        <td>
                            {{ (item.idade_letiva <= 5) ? item.posicao : '-' }}
                        </td>
                        <td>
                            <template v-if="item.matricula">
                                <a href="javascript:void(0)" @click="abreDossie(item)">{{ item.nome }}</a> 
                            </template>
                            <template v-if="!item.matricula">
                                {{ item.nome }}
                            </template>                            
                            <br>
                            <span style="font-style: italic; font-size: 12px;">{{ item.responsavel }}</span>
                        </td>
                        <td>
                            {{ $moment(item.data_nascimento).format('DD/MM/YYYY') }}
                        </td>  
                        <td>
                            {{ item.codigo_inscricao }}
                        </td>
                        <td> {{ item.celular }} </td>   
                        <td style="text-align: center;">
                            <el-tooltip placement="top">
                                <div slot="content">
                                    Inscrição: {{ $moment(item.created_at).format('DD/MM/YYYY HH:mm') }}<br><br>
                                    Confirmação: {{ $moment(item.pre_matricula_vaga_agendamento.data).format('DD/MM/YYYY') }}
                                </div>
                                <i class="el-icon-date"></i>
                            </el-tooltip>                            
                        </td>
                        <td>
                            <template v-if="item.idade_letiva <= 5">

                                <span v-if="!item.matricula_efetivada && item.cancelado" style="color: #ff0000; font-weight: bold;">CANCELADO</span>
                                <span v-if="!item.matricula_efetivada && !item.cancelado && item.situacao_vaga" style="color: #857104; font-weight: bold;">AGENDADO</span>
                                <span v-if="!item.matricula_efetivada && !item.cancelado && !item.situacao_vaga" style="color: #857104; font-weight: bold;">FILA DE ESPERA</span>
                                <span v-if="item.matricula_efetivada && !item.cancelado" style="color: #038915; font-weight: bold;">MATRICULADO</span>
                                
                            </template>
                            <template v-else>
                                <span v-if="item.matricula_efetivada" style="color: #038915; font-weight: bold;">MATRICULADO</span>
                                <span v-if="!item.matricula_efetivada && item.cancelado" style="color: #ff0000; font-weight: bold;">CANCELADO</span>
                                <span v-if="!item.matricula_efetivada && !item.cancelado" style="color: #857104; font-weight: bold;">AGENDADO</span>    
                            </template>                        
                        </td>
                        <td>
                            <el-button :disabled="item.matricula_efetivada || item.cancelado" @click="matricularAluno(item)" :type="item.matricula_efetivada || item.cancelado ? 'info' : 'primary'" :title="item.matricula_efetivada ? 'Matriculado' : (item.cancelado ? 'Matrícula cancelada' : 'Matrícular aluno')" icon="el-icon-circle-check" size="mini" ></el-button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div v-if="!statusList" class="u-text-center u-mt-25">
                <img src="/public/img/loading-bar.gif" />
            </div>
            <el-row :gutter="10" v-if="statusList">
                <el-col :xs="24" :sm="12" :md="12">
                    <div class="u-text-left u-mt-10">
                        Mostrando {{ paginate.from }} até {{ paginate.to }} de {{ paginate.qtdItens }} registros encontrados.
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="12" v-if="paginate.qtdItens > 30">
                    <div class="u-text-right">
                            <el-pagination :current-page='paginate.page' class="u-mt-10" :total="paginate.qtdItens" @current-change="getPagePagination" :page-size="30" background layout="prev, pager, next" small></el-pagination>
                        </div>
                </el-col>
            </el-row>
        </div>

        <el-dialog :close-on-click-modal="false" title="DOSSIÊ DO ALUNO" width="90%" top="40px" :visible.sync="dialogDossieAluno" v-on:close="closeDialogDossieAluno">
            <div v-if="dialogDossieAluno" style="margin-top: 20px;">
                <dossie-aluno :id="alunoIdSelected" v-on:changeDossie="changeDossie"></dossie-aluno>
            </div>
        </el-dialog>

    </div>
</template>
<script>

import dossieAluno from '@/components/aluno/dossie'

export default {
    data: () => ({
        loadingButtonPdf: false,
        alunoIdSelected: '',
        dialogDossieAluno: false,
        statusList: false,
        ref: [],
        filtro: {
            nome: '',
            instituicao_id: '',
            modalidade: '',
            data: '',
            situacao_vaga: ''
        },
        paginate: {
            page: 1,
            qtdItens: null,
            from: '',
            to: ''
        },
        items: [ ]
    }),
    mounted () {

        if(this.$store.state.config.instituicao && this.$store.state.user && this.$store.state.user.tipo <= 3){

            this.filtro.instituicao_id = this.$store.state.config.instituicao.id;
        }

        this.loadingInscritos()
    },
    methods: {
        abreDossie(item) {
                        
            this.alunoIdSelected = item.matricula.aluno_id;
            this.dialogDossieAluno = true;
        },
        matricularAluno(item) {

            let queryString = {
                id_pre_matricula: item.id,
                nome: item.nome.toUpperCase(),
                data_nascimento: item.data_nascimento,
                cpf: item.cpf,
                celular: item.celular,
                registro_nasc: item.registro_nasc, 
                responsavel: item.responsavel.toUpperCase(),
                turma_id: item.turma_id, 
                referencia_nacional: item.referencia_nacional,
                instituicao_id: item.instituicao_id
            }

            if(item.referencia_nacional >= 30 && item.referencia_nacional <= 34) {
                delete queryString.referencia_nacional;
                delete queryString.turma_id;
            }

            this.$router.push({ path: '/admin/matricula/passo-a-passo', query: queryString }).catch(() => {})
        },
        changeNome(){

            this.filtro.idade = '';
            this.changeFiltros();
        },
        changeFiltros(){

            this.paginate.page = 1;
            this.loadingInscritos();
        },
        loadingInscritos(){

            this.statusList = false;
            this.items = [];

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/pre-matricula/getAllInscritosNovatosPaginate?page=` + this.paginate.page, this.filtro, this.$store.getters.getHeaderAuth).then(response => {

                this.items = response.data.data;
                this.paginate.qtdItens = response.data.total;
                this.paginate.from = response.data.from;
                this.paginate.to = response.data.to;
                this.statusList = true;

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        renderPdfRelatorioInscritos(tipo){


            
            if(!this.filtro.instituicao_id && (this.$store.state.user.tipo <=3 || this.$store.state.user.tipo == 9)){
                
                window.eventBus.$emit('alert', {msg: 'Escolha uma instituição.', type: 'warning'});
                return false;
            }
            
            
            this.ref = [
                { nome: 'Instituição', valor: ((this.$store.state.user.tipo <=3 || this.$store.state.user.tipo == 9) ? this.$store.state.config.instituicao.nome : this.filtro.instituicao_id) },
            ];     
            
            if(tipo == 'agendados'){

                this.filtro.situacao_vaga = true;
                

            }else if(tipo == 'espera'){
                
                this.filtro.situacao_vaga = false;               
            
            }
                                  
            
            window.eventBus.$emit('print', {url: '/api/pdf/renderInscritosPreMatriculaNovatos', param: {ref: this.ref, filtros: this.filtro }});
            this.loadingButtonPdf = false;
            },
            async renderHtmlRelatorioGeralAluno(){ 
            
            try{
            
                let response = await this.getCodAutorizacaoRelatorioHtml();
            
                window.open(`${process.env.VUE_APP_BASE_URL}/api/relatorio/open/${response.data.token}`);            
                
            
            }catch(e){ 
            
                window.eventBus.$emit('alert', {msg: 'Erro ao gerar relatório.', type: 'warning'});
            }

        },
        getCodAutorizacaoRelatorioHtml(){

            return this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/relatorio/generateCodAutorizacaoPrintHtml/inscritos-pre-matricula-novatos`, {ref: this.ref, filtros: this.filtro}, this.$store.getters.getHeaderAuth);
        },
        getPagePagination(page){
          this.paginate.page = page;
          this.loadingInscritos();
        },
        closeDialogDossieAluno(){

            this.alunoSelected = {  };
        },
        changeDossie(actions){

            if(actions.close){

                this.dialogDossieAluno = false;
            }
        },
    },

    components:{ dossieAluno }
}
</script>